import React, { useCallback } from 'react';
import { Route, Switch, useHistory, useLocation } from 'react-router-dom';
import { injectIntl } from 'react-intl';

import { useSelector } from 'react-redux';
import config from 'config';

import LoadingSection from 'components/LoadingSection';
import { ContractsPage } from '@ontruck/fe-core';

const Contracts = ({ match, loading, className, intl }) => {
  const history = useHistory();
  const location = useLocation();
  const token = useSelector((state) => state?.user?.access_token);

  const contractsPageTranslations = intl.messages.components.Contracts.list;

  const consumerConfig = {
    api_url: `${config.BASE_URL}/`,
    token,
    on_success: () => {},
    on_discard: () => {},
  };

  const handleGoToNewContract = () => {
    history.push({ pathname: `${config.BASE_ROUTE}/contracts/new/` });
  };

  const handleGoToContractDetail = useCallback(
    (contractId) => {
      history.push({
        pathname: `${config.BASE_ROUTE}contracts/${contractId}`,
        state: { from: location.pathname },
      });
    },
    [history, location.pathname]
  );

  if (loading) {
    return <LoadingSection />;
  }

  return (
    <div className={className}>
      <Switch>
        <Route
          exact
          path={match.url}
          render={() => (
            <ContractsPage
              contractsPageTranslations={contractsPageTranslations}
              consumerConfig={consumerConfig}
              onGoToNew={handleGoToNewContract}
              onGotToDetail={handleGoToContractDetail}
            />
          )}
        />
      </Switch>
    </div>
  );
};

export default injectIntl(Contracts);
